export default __webpack_public_path__ + "static/media/photo-05.ce8d2e5c.jpeg";